<template>
    <div class="wrapper" :class="{ 'wrapper--embed': hideChrome }">
        <audio ref="audio" src="../../src/assets/img/newOrder.mp3" style="display:none"></audio>
        <template v-if="hideChrome">
                    <el-main class="embed-el-main">
                        <div class="embed-guide-bar ta-r">
                            <el-button
                                type="text"
                                icon="el-icon-question"
                                size="small"
                                @click="openFeatureGuide"
                            >新手指引</el-button>
                        </div>
                        <div
                            v-if="userInfo.code && !canMaintainHotel"
                            class="ebk-readonly-hint"
                            data-ebk-guide="readonly-hint"
                        >
                            当前为只读账号：可查看酒店详情、房型与价格，不可新增或修改酒店/房型/政策/房价房态。
                        </div>
                        <keep-alive
                    :key="userInfo.token || 'ebk'"
                    include="hotel,roomType,payRvDetailList,order,orderDetail"
                >
                    <router-view />
                </keep-alive>
            </el-main>
        </template>
        <template v-else>
            <el-container class="home-shell" direction="vertical">
                <el-header
                    v-show="!isMobile"
                    height="70px"
                    class="row ai-c jc-sb desk-header"
                >
                    <div class="row ai-c">
                        <img
                            src="../../src/assets/img/logo.png"
                            class="logo circle"
                        />
                        <span class="ml-2 fc-sub">{{ userInfo.name }}</span>
                    </div>
                    <div class="row ai-c cur-p">
                        <el-button
                            type="text"
                            icon="el-icon-question"
                            class="home-header-help-btn"
                            @click="openFeatureGuide"
                        >新手指引</el-button>
                        <el-menu
                            :default-active="activeIndex2"
                            class="el-menu-demo"
                            mode="horizontal"
                            @select="handleSelect"
                            text-color="#333"
                            active-text-color="#93a5cf"
                        >
                            <el-menu-item index="1">工作台</el-menu-item>
                            <el-submenu index="2">
                                <template slot="title">设置</template>
                                <el-menu-item index="23">切换供应商</el-menu-item>
                                <el-menu-item index="21">修改密码</el-menu-item>
                                <el-menu-item index="22">退出登录</el-menu-item>
                            </el-submenu>
                        </el-menu>
                    </div>
                </el-header>
                <el-header
                    v-show="isMobile"
                    height="56px"
                    class="row ai-c jc-sb mob-header"
                >
                    <div class="row ai-c fx-1">
                        <el-button
                            type="text"
                            icon="el-icon-menu"
                            class="mob-nav-btn"
                            data-ebk-guide="nav-menu"
                            @click="drawerVisible = true"
                            aria-label="打开菜单"
                        />
                        <img
                            src="../../src/assets/img/logo.png"
                            class="logo circle mob-logo"
                        />
                        <span class="ml-1 fc-sub mob-user-name">{{ userInfo.name }}</span>
                    </div>
                    <div class="row ai-c">
                        <el-button
                            type="text"
                            icon="el-icon-question"
                            class="mob-header-help-btn"
                            aria-label="新手指引"
                            @click="openFeatureGuide"
                        />
                    <el-dropdown trigger="click" @command="handleMobileMenuCommand">
                        <span class="mob-settings-btn cur-p">
                            <i class="el-icon-setting"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="switch">切换供应商</el-dropdown-item>
                            <el-dropdown-item command="pwd">修改密码</el-dropdown-item>
                            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    </div>
                </el-header>
                <el-container class="home-inner">
                    <el-aside v-show="!isMobile" width="200px" class="desk-aside">
                        <el-menu
                            data-ebk-guide="nav-menu"
                            :default-active="$route.path"
                            class="el-menu-vertical-demo"
                            :router="true"
                            text-color="#333"
                            active-text-color="#93a5cf"
                        >
                            <el-menu-item
                                index="/hotel"
                                :class="{ isActive: active == 1 }"
                            >
                                <i class="el-icon-s-data"></i>
                                酒店列表
                            </el-menu-item>
                            <el-menu-item
                                index="/roomType"
                                :class="{ isActive: active == 2 }"
                                v-if="false"
                            >
                                <i class="el-icon-menu"></i>
                                房型列表
                            </el-menu-item>
                            <el-menu-item
                                index="/order"
                                :class="{ isActive: active == 3 }"
                                data-ebk-guide="nav-order-badge"
                            >
                                <i class="el-icon-s-order"></i>
                                订单列表
                                <el-badge
                                    :value="totalCount"
                                    class="item"
                                    v-if="totalCount != '0'"
                                />
                            </el-menu-item>
                            <el-menu-item
                                index="/payRvDetailList"
                                :class="{ isActive: active == 4 }"
                            >
                                <i class="el-icon-s-data"></i>
                                结算列表
                            </el-menu-item>
                        </el-menu>
                    </el-aside>
                    <el-container direction="vertical" class="home-main-col">
                        <el-main class="home-el-main">
                            <div
                                v-if="userInfo.code && !canMaintainHotel"
                                class="ebk-readonly-hint"
                                data-ebk-guide="readonly-hint"
                            >
                                当前为只读账号：可查看酒店详情、房型与价格，不可新增或修改酒店/房型/政策/房价房态。
                            </div>
                            <keep-alive
                                :key="userInfo.token || 'ebk'"
                                include="hotel,roomType,payRvDetailList,order,orderDetail"
                            >
                                <router-view />
                            </keep-alive>
                        </el-main>
                        <el-footer
                            v-show="!isMobile"
                            height="70px"
                            class="row jc-c ai-c desk-footer"
                        >
                            <span class="fz-2 fc-sub">
                                Copyright © 2020 Smartcom. All rights reserved. |
                                沪ICP备11038251号-4 沪公网安备 31010702003873号
                            </span>
                        </el-footer>
                        <div v-show="isMobile" class="mob-footer fc-sub">
                            © 2020 Smartcom · 沪ICP备11038251号-4
                        </div>
                    </el-container>
                </el-container>
            </el-container>
            <el-drawer
                title="导航"
                :visible.sync="drawerVisible"
                direction="ltr"
                size="188px"
                custom-class="ebk-nav-drawer"
                append-to-body
            >
                        <el-menu
                            :default-active="$route.path"
                            class="el-menu-vertical-demo drawer-side-menu"
                            data-ebk-guide="nav-menu"
                            :router="false"
                            @select="handleDrawerMenuSelect"
                            text-color="#333"
                            active-text-color="#93a5cf"
                        >
                            <el-menu-item
                                index="/hotel"
                                :class="{ isActive: active == 1 }"
                            >
                                <i class="el-icon-s-data"></i>
                                酒店列表
                            </el-menu-item>
                            <el-menu-item
                                index="/roomType"
                                :class="{ isActive: active == 2 }"
                                v-if="false"
                            >
                                <i class="el-icon-menu"></i>
                                房型列表
                            </el-menu-item>
                            <el-menu-item
                                index="/order"
                                :class="{ isActive: active == 3 }"
                                data-ebk-guide="nav-order-badge"
                            >
                                <i class="el-icon-s-order"></i>
                                订单列表
                                <el-badge
                                    :value="totalCount"
                                    class="item"
                                    v-if="totalCount != '0'"
                                />
                            </el-menu-item>
                            <el-menu-item
                                index="/payRvDetailList"
                                :class="{ isActive: active == 4 }"
                            >
                                <i class="el-icon-s-data"></i>
                                结算列表
                            </el-menu-item>
                        </el-menu>
            </el-drawer>
        </template>
        <el-dialog
            title="修改密码"
            :visible.sync="centerDialogVisible"
            :width="pwdDialogWidth"
            :close-on-click-modal="false"
            custom-class="ebk-pwd-dialog"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                :label-position="isMobile ? 'top' : 'right'"
                :label-width="isMobile ? undefined : '100px'"
                class="demo-ruleForm"
            >
                <el-form-item label="新密码" prop="password">
                    <el-input
                        v-model="ruleForm.password"
                        prefix-icon="el-icon-lock"
                        clearable
                        show-password
                        class="input-width"
                    ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPassword">
                    <el-input
                        v-model="ruleForm.checkPassword"
                        prefix-icon="el-icon-lock"
                        clearable
                        show-password
                        class="input-width"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="resetForm('ruleForm')" class="mt-3"
                        >重置内容</el-button
                    >
                    <el-button type="primary" @click="submitForm('ruleForm')"
                        >立即修改</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import qs from "qs";
import { Message, MessageBox } from "element-ui";
import { shouldHideAppChrome } from "@/utils/embed";
import supplierMaintain from "@/mixins/supplierMaintain";
import {
    destroyActiveGuide,
    showOverviewOnManual,
} from "@/utils/featureGuide";

var timer = null;

export default {
    mixins: [supplierMaintain],
    data() {
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            audio: null,
            totalCount: 0,
            userInfo: {},
            active: 1,
            activeIndex2: "1",
            centerDialogVisible: false,
            drawerVisible: false,
            isMobile: false,
            ruleForm: {
                password: "",
                checkPassword: "",
            },
            rules: {
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                ],
                checkPassword: [{ validator: validatePass2, trigger: "blur" }],
            },
        };
    },
    computed: {
        hideChrome() {
            return shouldHideAppChrome();
        },
        pwdDialogWidth() {
            return this.isMobile ? "92%" : "480px";
        },
    },
    watch: {
        $route: function () {
            this.drawerVisible = false;
            this.syncActiveFromRoute();
            this.refreshUserInfoFromCookie();
        },
    },
    mounted() {
        if (typeof window !== "undefined" && window.matchMedia) {
            this._mq = window.matchMedia("(max-width: 992px)");
            this.isMobile = this._mq.matches;
            var self = this;
            this._onMq = function () {
                self.isMobile = self._mq.matches;
            };
            this._mq.addListener(this._onMq);
        }
        this.syncActiveFromRoute();
    },
    beforeDestroy() {
        destroyActiveGuide();
        clearInterval(timer);
        if (this._mq && this._onMq) {
            this._mq.removeListener(this._onMq);
        }
        try {
            MessageBox.close();
        } catch (e) {
            /* ignore */
        }
    },
    created() {
        if (this.getToken("userInfo")) {
            this.userInfo = JSON.parse(this.getToken("userInfo"));
        } else {
            this.$router.replace({ name: "login" });
            return;
        }
        timer = setInterval(() => {
            this.soPendingList();
        }, 100000);
    },
    methods: {
        openFeatureGuide() {
            var self = this;
            showOverviewOnManual(this).then(function (result) {
                if (result !== "start") {
                    return;
                }
                if (self.$startFeatureGuide) {
                    self.$startFeatureGuide(true);
                    return;
                }
                self.$root.$emit("ebk-start-feature-guide", {
                    manual: true,
                });
            });
        },
        syncActiveFromRoute() {
            var p = this.$route.path;
            if (p.indexOf("/payRvDetailList") !== -1) this.active = 4;
            else if (
                p.indexOf("/orderDetail") !== -1 ||
                p === "/order"
            )
                this.active = 3;
            else if (p.indexOf("/roomType") !== -1) this.active = 2;
            else if (p.indexOf("/hotel") !== -1) this.active = 1;
        },
        handleDrawerMenuSelect(index) {
            this.drawerVisible = false;
            if (!index) return;
            this.$router.push(index).catch(function (err) {
                if (
                    err &&
                    (err.name === "NavigationDuplicated" ||
                        err.name === "NavigationCancelled")
                ) {
                    return;
                }
                throw err;
            });
        },
        handleMobileMenuCommand: function (cmd) {
            if (cmd === "switch") this.switchSupplier();
            else if (cmd === "pwd") this.centerDialogVisible = true;
            else if (cmd === "logout") this.handleSelect("22");
        },
        refreshUserInfoFromCookie() {
            if (this.getToken("userInfo")) {
                try {
                    this.userInfo = JSON.parse(this.getToken("userInfo"));
                } catch (e) {
                    /* ignore */
                }
            }
        },
        switchSupplier() {
            if (!this.getToken("userInfo")) {
                this.$message.warning("请先登录");
                return;
            }
            this.$router.push({
                path: "/select-supplier",
                query: { mode: "switch" },
            });
        },
        soPendingList() {
            let data = {
                dp_id: this.userInfo.id,
            };
            this.$axios
                .soPendingList(qs.stringify(data))
                .then((res) => {
                    this.totalCount = res.totalCount;
                    if (res.totalCount != 0) {
                        if (
                            window.Notification &&
                            Notification.permission !== "denied"
                        ) {
                            Notification.requestPermission((status) => {
                                if (status === "granted") {
                                    this.$refs.audio.src = require("../../src/assets/img/newOrder.mp3");
                                    this.$refs.audio.play();
                                    let playPromise = this.$refs.audio.play();
                                    if (playPromise) {
                                        playPromise
                                            .then(() => {})
                                            .catch((err) => {
                                                console.error(err);
                                            });
                                    }
                                    var n = new Notification("通知", {
                                        body:
                                            "您有" +
                                            res.totalCount +
                                            "条新的订单待处理",
                                    });
                                    setTimeout(function () {
                                        n.close();
                                    }, 6000);
                                }
                            });
                        }
                    }
                })
                .catch(() => {
                    clearInterval(timer);
                });
        },
        handleSelect(key, keyPath) {
            if (key == 23) {
                this.switchSupplier();
            } else if (key == 21) {
                this.centerDialogVisible = true;
            } else if (key == 22) {
                clearInterval(timer);
                try {
                    MessageBox.close();
                } catch (e) {
                    /* ignore */
                }
                this.removeToken("userInfo");
                this.$router.replace({ name: "login" }).then(function () {
                    Message({
                        type: "info",
                        message: "您已退出登录，需重新登录",
                        duration: 3000,
                    });
                });
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.changeSupplierPassword();
                } else {
                    return false;
                }
            });
        },
        changeSupplierPassword() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let data = {
                da_id: this.userInfo.da_id,
                newPassword: this.ruleForm.password,
            };
            this.$axios
                .changeSupplierPassword(qs.stringify(data))
                .then((res) => {
                    loading.close();
                    if (res) {
                        this.centerDialogVisible = false;
                        clearInterval(timer);
                        try {
                            MessageBox.close();
                        } catch (e) {
                            /* ignore */
                        }
                        this.removeToken("userInfo");
                        this.$router.replace({ name: "login" }).then(function () {
                            Message({
                                type: "success",
                                message: "您已成功修改密码，需重新登录",
                                duration: 3000,
                            });
                        });
                    }
                })
                .catch(() => {
                    loading.close();
                });
        },
    },
};
</script>

<style scoped>
.wrapper,
.wrapper .el-menu-vertical-demo {
    height: 100%;
}
.logo {
    width: 50px;
    height: 50px;
}
.mob-logo {
    width: 40px;
    height: 40px;
}
.mob-user-name {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 42vw;
}
.mob-nav-btn {
    font-size: 22px;
    padding: 4px 8px 4px 0;
}
.mob-settings-btn {
    font-size: 22px;
    padding: 8px;
}
.desk-aside {
    background-color: #d3dce6;
    color: #333;
    text-align: center;
    line-height: 200px;
}

.home-el-main,
.embed-el-main {
    background-color: #e9eef3;
    color: #333;
    text-align: center;
}

.wrapper--embed {
    height: 100%;
    min-height: 100vh;
}

.embed-el-main {
    padding: 12px;
    box-sizing: border-box;
    min-height: 100vh;
}

.home-shell {
    margin-bottom: 40px;
    height: 100%;
}

.home-inner {
    flex: 1;
    min-height: 0;
}

.home-main-col {
    min-height: 0;
}

.mob-header {
    background: #fff;
    border-bottom: 1px solid #ebeef5;
    padding: 0 8px;
    flex-shrink: 0;
}

.desk-header {
    flex-shrink: 0;
}

.mob-footer {
    text-align: center;
    font-size: 11px;
    padding: 10px 8px calc(10px + env(safe-area-inset-bottom, 0px));
    background: #e9eef3;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
    line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
    line-height: 320px;
}
.el-menu--horizontal {
    border: none;
}
</style>

<style>
/* 移动端侧滑导航：宽度随内容，避免右侧大块空白 */
.ebk-nav-drawer.el-drawer.ltr {
    width: min(188px, 50vw) !important;
    max-width: 188px;
}
.ebk-nav-drawer .el-drawer__header {
    padding: 14px 12px 10px;
    margin-bottom: 0;
}
.ebk-nav-drawer .el-drawer__header > span {
    font-size: 15px;
    font-weight: 600;
}
.ebk-nav-drawer .el-drawer__body {
    padding: 0;
}
.ebk-nav-drawer .drawer-side-menu,
.ebk-nav-drawer .el-menu-vertical-demo {
    width: 100%;
    border-right: none;
    text-align: left;
}
.ebk-nav-drawer .drawer-side-menu .el-menu-item {
    height: 46px;
    line-height: 46px;
    padding: 0 14px !important;
    font-size: 14px;
    box-sizing: border-box;
}
.ebk-nav-drawer .drawer-side-menu .el-menu-item i {
    margin-right: 6px;
}
.input-width {
    max-width: 100%;
}
.ebk-pwd-dialog .el-dialog__body {
    padding-top: 10px;
}
.ebk-readonly-hint {
    margin: 0 0 10px;
    padding: 8px 12px;
    font-size: 13px;
    line-height: 1.5;
    color: #e6a23c;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    border-radius: 6px;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue